<template>
  <VDivider
    :color="color"
    :vertical="vertical"
    :length="length"
    class="ui-divider"
  />
</template>

<script setup lang="ts">
import { VDivider } from 'vuetify/components/VDivider';

export interface Props {
  color?: string;
  vertical?: boolean;
  length?: string;
}

withDefaults(defineProps<Props>(), {
  color: undefined,
  vertical: false,
  length: undefined,
});
</script>

<style scoped lang="scss">
.ui-divider {
  color: rgb(var(--v-theme-text-tertiary));
}
</style>
